import { UserSettings } from '../../components/UserSettings';

export const Settings: React.FC = () => {
  return <UserSettings />;
};
